module.exports = __webpack_public_path__ + "static/media/UofT.7d5c8b92.png";